import { CategoryBarChartAppearance } from '@frontend/charts';
import { theme } from '@frontend/theme';
import { MutliChartTooltipTitle } from '../components/multi-chart-tooltip-title';
import type { ROIFilters } from '../hooks/use-nsr-roi-store';

export const commonMultiAppearance = (filters?: ROIFilters): CategoryBarChartAppearance => ({
  barSize: 40,
  collectiveTooltip: true,
  customTooltipTitle: ({ groupName }) => (
    <MutliChartTooltipTitle locationId={groupName} startDate={filters?.startDate} endDate={filters?.endDate} />
  ),
  groupsGap: 40,
  labelConfig: {
    customStyles: () => ({
      dy: 8,
      fill: theme.font.colors.default,
      fontSize: theme.font.size.h2,
      fontWeight: theme.font.weight.bold,
    }),
    distanceFromBar: 70,
    placement: 'start',
    show: true,
  },
  margin: { left: 75 },
});
